import { render, staticRenderFns } from "./registrationByVehicleCategory.vue?vue&type=template&id=d9056244"
import script from "./registrationByVehicleCategory.vue?vue&type=script&lang=js"
export * from "./registrationByVehicleCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports